import log from "../../utils/logger/library";
import { set_loading_complete } from "../../actions/Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import { all_regions } from "../../reducers/Regions/reducer";
import { fetch_regions } from "../../fetch/graphql/requests/regions";
import { parseContentListingItems } from "../../utils/dataTransform";
import { REGIONS_VISIBLE_IN_NAV } from "../../utils/regions/library";
import { getSwimLaneList } from "../SwimlaneList/utils";
import { receive_sectional_content } from "../../reducers/SectionalContent/reducer";

/**
 * @fetch_all_regions_graphql
 * Trigger the GraphQL fetching of all regions
 * @returns {void}
 */
export function fetch_all_regions_graphql(cardCount = 1) {
    return async (dispatch) => {
        dispatch(start_loading());

        try {
            const { data: regions, errors } = await fetch_regions(cardCount);

            if (errors) {
                for (const error of errors) {
                    log.error(
                        "(fetch_all_regions_graphql) fetch_regions request failed",
                        new Error(
                            `(fetch_all_regions_graphql) fetch_regions request failed on ${error.path[0]} - [${error.message}]`,
                            { cause: error }
                        )
                    );
                }
            }

            // Append graph data to the region object and do transformation
            const regionList = parseContentListingItems(
                REGIONS_VISIBLE_IN_NAV,
                regions
            );

            dispatch(all_regions({ regionList }));
        } catch (error) {
            log.error(`(fetch_all_regions_graphql) request failed`, error);
            throw error;
        } finally {
            dispatch(set_loading_complete());
        }
    };
}

export const getLocalSection =
    (path, section, slug, subjects, excludedCategorySet, type) =>
    (dispatch) => {
        const swimlaneList = getSwimLaneList(path);

        if (type === "flp") {
            if (subjects !== "" || excludedCategorySet !== "") {
                swimlaneList.push({
                    section: `${section}`,
                    type: "localSubject",
                    itemCount: 4,
                    subjects,
                    excludedCategorySet,
                });
            } else {
                return Promise.resolve();
            }
        }

        const localSectionList = swimlaneList
            .filter((it) => it.type === "localSubject")
            .map((obj) => {
                obj.slug = slug;
                return obj;
            });
        if (localSectionList.length === 0) {
            return Promise.resolve();
        }
        return fetch(localSectionList).then((list) => {
            return list
                .map((it) =>
                    receive_sectional_content({
                        sectionList: it.response,
                        section: it.section,
                        timestamp: Date.now(),
                    })
                )
                .map((it) => dispatch(it));
        });
    };
